import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface Question {
  component_text: string;
}

@Component({
	selector: 'wcc-info-box',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './info-box.component.html',
	styleUrl: './info-box.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoBoxComponent {
	@Input() type: 'info' | 'warning' = 'info';
	@Input() content = '';
}
